module.exports = __webpack_public_path__ + "img/form.4e903ede.svg";